import React from 'react';

import FormsHradminEmployeeSearchBarForm from '../../../forms/hradmin/employee/search_bar';

const HradminEmployeeSearchBar = (props) => {
    return (
        <FormsHradminEmployeeSearchBarForm
            updateSearchParameters={props.updateSearchParameters}
        />
    );
}

export default HradminEmployeeSearchBar;